import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';

const ChatContentHeader = ({ setHideSidebar, conversation }) => {
  const { setIsOpenConversationInfo, neighborhoodsObj } =
    useContext(ChatContext);
  const { client: user, property, project } = conversation;

  return (
    <div className="chat-content-header" style={{ height: 68 }}>
      <Row className="flex-between-center h-100">
        <Col
          xs={6}
          md={8}
          as={Flex}
          alignItems="center"
          style={{ flexGrow: 1 }}
        >
          <div
            className="pe-3 text-700 d-md-none contacts-list-show cursor-pointer"
            onClick={() => setHideSidebar(true)}
          >
            <FontAwesomeIcon icon="chevron-left" />
          </div>

          <div className="min-w-0">
            <h5 className="mb-0 text-truncate fs-0">{`${user.firstName} ${
              user.lastName
            }${
              property
                ? ` - ${property.location.street} ${
                    property.location.number
                  }, ${
                    property.location.barrios[1]
                      ? ` ${neighborhoodsObj[property.location.barrios[1]]}`
                      : neighborhoodsObj[property.location.barrios[0]]
                  }`
                : project
                ? ` - ${project.location.street} ${project.location.number}, ${
                    project.location.barrios[1]
                      ? ` ${neighborhoodsObj[project.location.barrios[1]]}`
                      : neighborhoodsObj[project.location.barrios[0]]
                  }`
                : ''
            }`}</h5>
          </div>
        </Col>

        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Información de la conversación</Tooltip>}
          >
            <Button
              variant="falcon-primary"
              size="sm"
              onClick={() => setIsOpenConversationInfo(prev => !prev)}
            >
              <FontAwesomeIcon icon="info" />
            </Button>
          </OverlayTrigger>
        </Col>
      </Row>
    </div>
  );
};

ChatContentHeader.propTypes = {
  setHideSidebar: PropTypes.func.isRequired,
  conversation: PropTypes.object.isRequired
};

export default ChatContentHeader;
